/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Section_ArchitectureInputs */

const en_marketing_section_architecture = /** @type {(inputs: Marketing_Section_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const es_marketing_section_architecture = /** @type {(inputs: Marketing_Section_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura`)
};

const fr_marketing_section_architecture = /** @type {(inputs: Marketing_Section_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

/**
* | output |
* | --- |
* | "Architecture" |
*
* @param {Marketing_Section_ArchitectureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_section_architecture = /** @type {((inputs?: Marketing_Section_ArchitectureInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Section_ArchitectureInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_section_architecture(inputs)
	if (locale === "es") return es_marketing_section_architecture(inputs)
	return fr_marketing_section_architecture(inputs)
});